// @ts-nocheck
// Using public directory paths instead of direct imports

interface InstructionSet {
  title: string
  section: string
  sectionRaw: string
  steps: string[]
  note?: string
}

interface ModuleContent {
  [moduleId: string]: {
    content: InstructionSet[]
    articleTitle?: string
    description?: string
    image_main?: string
    image?: string
  }
}

// Define image paths
const publicImagePaths = {
  how_to_set_up_kompakt_img_main:
    "/images/sections/kompakt-qs/how_to_set_up_your_kompakt/KOMPAKT_SET_UP_MAIN.png",
  how_to_set_up_kompakt_img_1:
    "/images/sections/kompakt-qs/how_to_set_up_your_kompakt/KOMPAKT_SET_UP_1.png",
  how_to_set_up_kompakt_img_2:
    "/images/sections/kompakt-qs/how_to_set_up_your_kompakt/KOMPAKT_SET_UP_2.png",
  how_to_call_and_message_img_main:
    "/images/sections/kompakt-qs/how_to_call_and_message/CALL_MESSAGE_MAIN.png",
  how_to_call_and_message_img_1:
    "/images/sections/kompakt-qs/how_to_call_and_message/CALL_MESSAGE_1.png",
  how_to_call_and_message_img_2:
    "/images/sections/kompakt-qs/how_to_call_and_message/CALL_MESSAGE_2.png",
  how_to_call_and_message_img_3:
    "/images/sections/kompakt-qs/how_to_call_and_message/CALL_MESSAGE_3.png",
  how_to_stay_organized_img_main:
    "/images/sections/kompakt-qs/how_to_stay_organized/STAY_ORGANIZED_MAIN.png",
  how_to_stay_organized_img_1:
    "/images/sections/kompakt-qs/how_to_stay_organized/STAY_ORGANIZED_1.png",
  how_to_stay_organized_img_2:
    "/images/sections/kompakt-qs/how_to_stay_organized/STAY_ORGANIZED_2.png",
  how_to_stay_organized_img_3:
    "/images/sections/kompakt-qs/how_to_stay_organized/STAY_ORGANIZED_3.png",
  how_to_take_and_view_photos_img_main:
    "/images/sections/kompakt-qs/how_to_take_and_view_photos/PHOTOS_MAIN.png",
  how_to_take_and_view_photos_img_1:
    "/images/sections/kompakt-qs/how_to_take_and_view_photos/PHOTOS_1.png",
  how_to_take_and_view_photos_img_2:
    "/images/sections/kompakt-qs/how_to_take_and_view_photos/PHOTOS_2.png",
  how_to_use_offline_plus_img_main:
    "/images/sections/kompakt-qs/how_to_use_offline_plus/OFFLINE_1.png",
  how_to_update_kompakt_img_main:
    "/images/sections/kompakt-qs/how_to_update_kompakt/KOMPAKT_UPDATE_1.png",
  how_to_sync_and_backup_kompakt_img_main:
    "/images/sections/kompakt-qs/how_to_sync_and_backup_with_mudita_center/SYNC_BACKUP_MAIN.png",
  how_to_sync_and_backup_kompakt_img_1:
    "/images/sections/kompakt-qs/how_to_sync_and_backup_with_mudita_center/SYNC_BACKUP_1.png",
  how_to_sync_and_backup_kompakt_img_2:
    "/images/sections/kompakt-qs/how_to_sync_and_backup_with_mudita_center/SYNC_BACKUP_2.png",
  recorder_app_img_main:
    "/images/sections/kompakt-qs/recorder_app/RECORDER_APP_MAIN.png",
  recorder_app_img_1:
    "/images/sections/kompakt-qs/recorder_app/RECORDER_APP_1.png",
  recorder_app_img_2:
    "/images/sections/kompakt-qs/recorder_app/RECORDER_APP_2.png",
  recorder_app_img_3:
    "/images/sections/kompakt-qs/recorder_app/RECORDER_APP_3.png",
  privacy_and_security_img_main:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_MAIN.png",
  privacy_and_security_img_1:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_01.png",
  privacy_and_security_img_2:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_02.png",
  privacy_and_security_img_3:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_03.png",
  privacy_and_security_img_4:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_04.png",
  privacy_and_security_img_5:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_05.png",
  privacy_and_security_img_6:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_06.png",
  privacy_and_security_img_7:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_07.png",
  privacy_and_security_img_8:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_08.png",
  privacy_and_security_img_9:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_09.png",
  basic_settings_and_customization_img_main:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_MAIN.png",
  basic_settings_and_customization_img_1:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_01.png",
  basic_settings_and_customization_img_2:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_02.png",
  basic_settings_and_customization_img_3:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_03.png",
  basic_settings_and_customization_img_4:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_04.png",
  basic_settings_and_customization_img_5:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_05.png",
  basic_settings_and_customization_img_6:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_06.png",
  basic_settings_and_customization_img_7:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_07.png",
  connectivity_img_main:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_MAIN.png",
  connectivity_img_1:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_1.png",
  connectivity_img_2:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_2.png",
  connectivity_img_3:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_3.png",
  connectivity_img_4:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_4.png",
  connectivity_img_5:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_5.png",
  connectivity_img_6:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_6.png",
  connectivity_img_7:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_7.png",
  connectivity_img_8:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_8.png",
  connectivity_img_9:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_9.png",
  connectivity_img_10:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_10.png",
  connectivity_img_11:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_11.png",
  troubleshooting_img_main:
    "/images/sections/kompakt-qs/troubleshooting/TROUBLESHOOTING_MAIN.png",
  troubleshooting_img_1:
    "/images/sections/kompakt-qs/troubleshooting/TROUBLESHOOTING_1.png",
  troubleshooting_img_2:
    "/images/sections/kompakt-qs/troubleshooting/TROUBLESHOOTING_2.png",
  troubleshooting_img_3:
    "/images/sections/kompakt-qs/troubleshooting/TROUBLESHOOTING_3.png",
  troubleshooting_img_4:
    "/images/sections/kompakt-qs/troubleshooting/TROUBLESHOOTING_4.png",
  alarm_app_img_main: "/images/sections/kompakt-qs/alarm_app/ALARM_APP.png",
  alarm_app_img_1: "/images/sections/kompakt-qs/alarm_app/ALARM_APP_1.png",
  alarm_app_img_2: "/images/sections/kompakt-qs/alarm_app/ALARM_APP_2.png",
  alarm_app_img_3: "/images/sections/kompakt-qs/alarm_app/ALARM_APP_3.png",
  alarm_app_img_4: "/images/sections/kompakt-qs/alarm_app/ALARM_APP_4.png",
  messaging_img_main:
    "/images/sections/kompakt-qs/messaging/MESSAGING_MAIN.png",
  messaging_img_1: "/images/sections/kompakt-qs/messaging/MESSAGING_1.png",
  messaging_img_2: "/images/sections/kompakt-qs/messaging/MESSAGING_2.png",
  messaging_img_3: "/images/sections/kompakt-qs/messaging/MESSAGING_3.png",
  messaging_img_4: "/images/sections/kompakt-qs/messaging/MESSAGING_4.png",
  messaging_img_5: "/images/sections/kompakt-qs/messaging/MESSAGING_5.png",
  camera_app_img_main:
    "/images/sections/kompakt-qs/camera_app/CAMERA_APP_MAIN.png",
  camera_app_img_1: "/images/sections/kompakt-qs/camera_app/CAMERA_APP_1.png",
  camera_app_img_2: "/images/sections/kompakt-qs/camera_app/CAMERA_APP_2.png",
  camera_app_img_3: "/images/sections/kompakt-qs/camera_app/CAMERA_APP_3.png",
  camera_app_img_4: "/images/sections/kompakt-qs/camera_app/CAMERA_APP_4.png",
  notes_img_main: "/images/sections/kompakt-qs/notes_app/NOTES_APP_MAIN.png",
  notes_img_1: "/images/sections/kompakt-qs/notes_app/NOTES_APP_1.png",
  notes_img_2: "/images/sections/kompakt-qs/notes_app/NOTES_APP_2.png",
  maps_app_img_main: "/images/sections/kompakt-qs/maps_app/MAPS_APP_MAIN.png",
  maps_app_img_1: "/images/sections/kompakt-qs/maps_app/MAPS_APP_1.png",
  maps_app_img_2: "/images/sections/kompakt-qs/maps_app/MAPS_APP_2.png",
  weather_app_img_main:
    "/images/sections/kompakt-qs/weather_app/WEATHER_APP_MAIN.png",
  weather_app_img_1:
    "/images/sections/kompakt-qs/weather_app/WEATHER_APP_1.png",
  weather_app_img_2:
    "/images/sections/kompakt-qs/weather_app/WEATHER_APP_2.png",
  weather_app_img_3:
    "/images/sections/kompakt-qs/weather_app/WEATHER_APP_3.png",
  managing_files_img_main:
    "/images/sections/kompakt-qs/managing_files/MANAGING_FILES_MAIN.png",
  managing_files_img_1:
    "/images/sections/kompakt-qs/managing_files/MANAGING_FILES_1.png",
  managing_files_img_2:
    "/images/sections/kompakt-qs/managing_files/MANAGING_FILES_2.png",
  managing_files_img_3:
    "/images/sections/kompakt-qs/managing_files/MANAGING_FILES_3.png",
  managing_files_img_4:
    "/images/sections/kompakt-qs/managing_files/MANAGING_FILES_4.png",
  backup_and_restore_img_main:
    "/images/sections/kompakt-qs/backup_and_restore/BACKUP_RESTORE_MAIN.png",
  backup_and_restore_img_1:
    "/images/sections/kompakt-qs/backup_and_restore/BACKUP_RESTORE_1.png",
  backup_and_restore_img_2:
    "/images/sections/kompakt-qs/backup_and_restore/BACKUP_RESTORE_2.png",
  backup_and_restore_img_3:
    "/images/sections/kompakt-qs/backup_and_restore/BACKUP_RESTORE_3.png",
  updating_kompakt_img_main:
    "/images/sections/kompakt-qs/updating_kompakt/UPDATING_KOMPAKT_MAIN.png",
  updating_kompakt_img_1:
    "/images/sections/kompakt-qs/updating_kompakt/UPDATING_KOMPAKT_01.png",
  updating_kompakt_img_2:
    "/images/sections/kompakt-qs/updating_kompakt/UPDATING_KOMPAKT_02.png",
  calling_img_main: "/images/sections/kompakt-qs/calling/CALLING_MAIN.png",
  calling_img_1: "/images/sections/kompakt-qs/calling/CALLING_01.png",
  calling_img_2: "/images/sections/kompakt-qs/calling/CALLING_02.png",
  managing_contacts_img_main:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_MAIN.png",
  managing_contacts_img_1:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_01.png",
  managing_contacts_img_2:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_02.png",
  managing_contacts_img_3:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_03.png",
  managing_contacts_img_4:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_04.png",
  managing_contacts_img_5:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_05.png",
  managing_contacts_img_6:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_06.png",
  managing_contacts_img_7:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_07.png",
  managing_contacts_img_8:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_08.png",
  managing_contacts_img_9:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_09.png",
  managing_contacts_img_10:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_10.png",
  managing_contacts_img_11:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_11.png",
  calendar_app_img_main:
    "/images/sections/kompakt-qs/calendar_app/CALENDAR_APP_01.png",
}

export const moduleContentPl: ModuleContent = {
  // How to set up your Kompakt section
  "sim-card": {
    image_main: publicImagePaths.how_to_set_up_kompakt_img_main,
    image: publicImagePaths.how_to_set_up_kompakt_img_1,
    content: [
      {
        title: "Jak włożyć fizyczną kartę SIM",
        section: "Jak skonfigurować Kompakt",
        sectionRaw: "How to set up your Kompakt",
        steps: [
          "Włóż <strong>kluczyk SIM</strong> do okrągłego otworu",
          "Całkowicie wyciągnij tackę na <strong>kartę SIM</strong>",
          "Włóż kartę <strong>SIM</strong> do tacki – złotą stroną do dołu",
          "Włóż tackę z powrotem do Kompakta",
        ],
      },
    ],
  },
  "first-setup": {
    image_main: publicImagePaths.how_to_set_up_kompakt_img_main,
    image: publicImagePaths.how_to_set_up_kompakt_img_2,
    content: [
      {
        title: "Jak uruchomić Kompakt za pierwszym razem",
        section: "Jak skonfigurować Kompakt",
        sectionRaw: "How to set up your Kompakt",
        steps: [
          "Naciśnij przycisk <strong>Zasilania</strong>",
          "Wybierz <strong>Language setup</strong>",
          "Wybierz język",
          "Włóż kartę SIM, aby zyskać pełną funkcjonalność swojego Kompakta, lub wybierz <strong>Pomiń</strong>",
          "Wybierz sieć Wi-Fi, do której chcesz dołączyć",
          "Wpisz hasło",
          "Wybierz <strong>Dalej</strong>",
          "Przeczytaj Umowę… > wybierz <strong>Zaakceptuj</strong>",
          "Wpisz nowy 6-cyfrowy kod",
          "Wybierz <strong>Potwierdź kod</strong>",
          "Wpisz 6-cyfrowy kod ponownie",
          "Wybierz <strong>Ustaw kod</strong>",
          "Wybierz <strong>Dalej</strong>",
          "Oprzyj palec na czytniku linii papilarnych",
          "Po wibracji unieś palec",
          "Kontynuuj opieranie i unoszenie palca, za każdym nieznacznie zmieniając jego ułożenie na przycisku zasilania.",
          "Wybierz <strong>Gotowe</strong>",
          "Wybierz <strong>Szybki samouczek*</strong> i użyj przycisku <strong>Gotowe</strong> do przechodzenia do kolejnych stron",
          "Jeśli jest dostępna aktualizacja oprogramowania, zainstaluj ją i uruchom urządzenie ponownie.",
          "Jeśli oprogramowanie jest aktualne, możesz już korzystać ze swojego Kompakta.",
        ],
        note: "*Pominięcie samouczka nie ma wpływu na ustawienia telefonu.",
      },
    ],
  },

  // How to Call and Message section
  "adding-contacts": {
    image_main: publicImagePaths.how_to_call_and_message_img_main,
    image: publicImagePaths.how_to_call_and_message_img_1,
    articleTitle: "Jak dodać kontakty do Kompakta",
    description: `Istnieją 3 główne sposoby dodawania kontaktów. Możesz dodać je ręcznie, bezpośrednio na Kompakcie, lub zaimportować kontakty z konta Google albo Outlook. Możesz także zaimportować kontakty z Apple, ale najpierw musisz utworzyć plik vCard.`,
    content: [
      {
        title: "Aby dodać pojedynczy kontakt na Kompakcie:",
        section: "Jak dzwonić i wysyłać wiadomości",
        sectionRaw: "How to call and message",
        steps: [
          "Wybierz <strong>Telefon</strong>",
          "Wybierz <strong>Kontakty</strong>",
          "Wybierz ikonę <strong>Dodaj kontakt</strong>",
          "Wprowadź dane kontaktu",
          "Wybierz <strong>Utwórz</strong>",
        ],
      },
      {
        title: "Aby zaimportować kontakty z konta Google lub Outlook:",
        section: "Jak dzwonić i wysyłać wiadomości",
        sectionRaw: "How to call and message",
        steps: [
          "Otwórz Mudita Center i podłącz Kompakt",
          "Wybierz <strong>Twój Kompakt</strong> > <strong>Kontakty</strong>",
          "Kliknij <strong>Importuj kontakty</strong>",
          "Wybierz, z którego konta chcesz zaimportować kontakty",
          "Zaloguj się do wybranego konta",
          "Zaznacz wybrane kontakty lub wybierz <strong>Wszystkie kontakty</strong>",
          "Kliknij <strong>Importuj wybrane kontakty</strong>, aby przesłać je na telefon*",
        ],
        note: "* Ważne: nie odłączaj telefonu podczas procesu importu!",
      },
      {
        title: "Aby zaimportować kontakty z pliku CSV lub vCard:",
        section: "Jak dzwonić i wysyłać wiadomości",
        sectionRaw: "How to call and message",
        steps: [
          "Otwórz aplikację Mudita Center i podłącz urządzenie",
          "Wybierz <strong>Twój Kompakt</strong> > <strong>Kontakty</strong>",
          "Kliknij <strong>Importuj kontakty</strong>",
          "Kliknij <strong>Prześlij plik CSV lub vCard</strong>",
          "Wybierz plik CSV lub vCard z komputera",
          "Zaznacz wybrane kontakty lub wybierz <strong>Wszystkie kontakty</strong>",
          "Kliknij <strong>Importuj wybrane kontakty</strong>, aby przesłać je na telefon*",
        ],
        note: "* Ważne: nie odłączaj telefonu podczas trwania procesu importu!",
      },
    ],
  },
  "making-calls": {
    image_main: publicImagePaths.how_to_call_and_message_img_main,
    image: publicImagePaths.how_to_call_and_message_img_2,
    articleTitle: "Jak zadzwonić z Mudita Kompakt",
    content: [
      {
        title: "Aby zadzwonić do zapisanego kontaktu:",
        section: "Jak dzwonić i wysyłać wiadomości",
        sectionRaw: "How to call and message",
        steps: [
          "Wybierz <strong>Telefon</strong>",
          "Wybierz <strong>Kontakty</strong>",
          "Wybierz kontakt, do którego chcesz zadzwonić",
          "Wybierz ikonę <strong>Zadzwoń</strong>",
        ],
      },
      {
        title: "Aby zadzwonić na nowy numer:",
        section: "Jak dzwonić i wysyłać wiadomości",
        sectionRaw: "How to call and message",
        steps: [
          "Wybierz <strong>Telefon</strong>",
          "Wybierz <strong>Wybierz numer</strong>",
          "Wprowadź numer, na który chcesz zadzwonić",
          "Wybierz ikonę <strong>Zadzwoń</strong>",
        ],
      },
    ],
  },
  "sending-messages": {
    image_main: publicImagePaths.how_to_call_and_message_img_main,
    image: publicImagePaths.how_to_call_and_message_img_3,
    articleTitle: "Jak wysyłać wiadomości SMS i MMS",
    description: `Możesz łatwo wysyłać wiadomości do kontaktów lub na <b>nowe numery</b>.`,
    content: [
      {
        title: "Aby wysłać wiadomość SMS do kontaktu:",
        section: "Jak dzwonić i wysyłać wiadomości",
        sectionRaw: "How to call and message",
        steps: [
          "Wybierz <strong>SMS</strong>",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Wybierz kontakt, do którego chcesz napisać",
          "Wpisz treść wiadomości*",
          "Wybierz ikonę <strong>Wyślij</strong>",
        ],
        note: "*Jeśli klawiatura się nie pojawi automatycznie, dotknij migającego kursora w polu tekstowym",
      },
      {
        title: "Aby wysłać wiadomość MMS do kontaktu:",
        section: "Jak dzwonić i wysyłać wiadomości",
        sectionRaw: "How to call and message",
        steps: [
          "Wybierz <strong>SMS</strong>",
          "Wybierz ikonę <strong>Plusa</strong>",
          "Wybierz kontakt, do którego chcesz napisać",
          "Wybierz ikonę <strong>Obrazu</strong>",
          "Wybierz obraz, który chcesz wysłać",
          "Wybierz <strong>Wyślij</strong>",
        ],
      },
    ],
  },

  // How to Stay Organized section
  notes: {
    image_main: publicImagePaths.how_to_stay_organized_img_main,
    image: publicImagePaths.how_to_stay_organized_img_1,
    content: [
      {
        title: "Jak tworzyć notatki:",
        section: "Organizacja",
        sectionRaw: "How to Stay Organized",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Notatki</strong>",
          "Wybierz ikonę <strong>Plus</strong>*",
          "Wpisz tytuł notatki (maks. 54 znaki)",
          "Wybierz <strong>Enter</strong> na klawiaturze",
          "Wpisz treść notatki",
          "Wybierz <strong>Gotowe</strong>",
        ],
        note: "*Jeśli to Twoja pierwsza notatka, wybierz <strong>Utwórz nową notatkę</strong>.",
      },
      {
        title: "Jak usuwać notatki:",
        section: "Organizacja",
        sectionRaw: "How to Stay Organized",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Notatki</strong>",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Zaznacz <strong>Pole wyboru</strong> obok notatki lub notatek, które chcesz usunąć",
          "Wybierz <strong>Usuń</strong>",
          "Ponownie wybierz <strong>Usuń</strong>",
        ],
      },
    ],
  },
  calendar: {
    image_main: publicImagePaths.how_to_stay_organized_img_main,
    image: publicImagePaths.how_to_stay_organized_img_2,
    content: [
      {
        title: "Jak utworzyć wydarzenie w Kalendarzu:",
        section: "Organizacja",
        sectionRaw: "How to Stay Organized",
        steps: [
          "Wybierz <strong>Aplikacje</strong>*",
          "Wybierz <strong>Kalendarz</strong>",
          "Użyj strzałek w lewo i prawo, aby wybrać miesiąc",
          "Wybierz dzień, w którym chcesz dodać wydarzenie",
          "Wybierz ikonę <strong>Plusa</strong>",
          "Wybierz <strong>Dodaj tytuł</strong>, aby nadać wydarzeniu nazwę",
          "Użyj strzałek góra/dół, aby ustawić godzinę rozpoczęcia",
          "Użyj strzałek góra/dół, aby ustawić godzinę zakończenia",
          "Wybierz <strong>Utwórz</strong>",
        ],
        note: "*Możesz także wybrać dzisiejszą datę na ekranie głównym, by przejść do Kalendarza*",
      },
    ],
  },
  alarms: {
    image_main: publicImagePaths.how_to_stay_organized_img_main,
    image: publicImagePaths.how_to_stay_organized_img_3,
    content: [
      {
        title: "Jak utworzyć pierwszy alarm:",
        section: "Organizacja",
        sectionRaw: "How to Stay Organized",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Alarm</strong>",
          "Wybierz <strong>Utwórz alarm</strong>",
          "Możesz edytować nazwę, dźwięk oraz dni, w które ma się powtarzać*",
          "Wybierz <strong>Utwórz</strong>",
        ],
        note: "*Długość drzemki jest stała i wynosi 5 minut.",
      },
      {
        title: "Jak dodać kolejny alarm:",
        section: "Organizacja",
        sectionRaw: "How to Stay Organized",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Alarm</strong>",
          "Wybierz ikonę <strong>Plusa</strong>",
          "Możesz edytować nazwę, dźwięk oraz dni, w które ma się powtarzać*",
          "Wybierz <strong>Utwórz</strong>",
        ],
        note: "*Długość drzemki jest stała i wynosi 5 minut.",
      },
    ],
  },

  // How to take and view photos section
  "view-photos": {
    image_main: publicImagePaths.how_to_take_and_view_photos_img_main,
    image: publicImagePaths.how_to_take_and_view_photos_img_1,
    description: `Możesz przeglądać zdjęcia na Kompakcie tylko w odcieniach szarości, ale po przesłaniu ich do komputera przez <b>Mudita Center</b> zobaczysz je w pełnym kolorze.`,
    content: [
      {
        title: "Jak przeglądać zdjęcia:",
        section: "Zdjęcia i aparat",
        sectionRaw: "How to take and view photos",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Aparat</strong>",
          "Wybierz ikonę <strong>Obrazu</strong>",
          "Wybierz zdjęcie, które chcesz obejrzeć",
        ],
        note: "Możesz przeglądać zdjęcia na Kompakcie tylko w odcieniach szarości, ale po przesłaniu ich do komputera przez Mudita Center zobaczysz je w pełnym kolorze.",
      },
    ],
  },
  "take-photos": {
    image_main: publicImagePaths.how_to_take_and_view_photos_img_main,
    image: publicImagePaths.how_to_take_and_view_photos_img_2,
    content: [
      {
        title: "Jak zrobić zdjęcie:",
        section: "Zdjęcia i aparat",
        sectionRaw: "How to take and view photos",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Aparat</strong>",
          "Skieruj aparat na obiekt",
          "Wybierz przycisk <strong>Zdjęcie</strong>*",
        ],
        note: "*Ponieważ Kompakt ma wyświetlacz e-ink, może być konieczne przytrzymanie telefonu nieruchomo nieco dłużej niż w przypadku typowego smartfona.",
      },
    ],
  },

  // How to use Offline+ section
  "using-offline-plus": {
    image_main: publicImagePaths.how_to_use_offline_plus_img_main,
    image: publicImagePaths.how_to_use_offline_plus_img_main,
    content: [
      {
        title: "Jak korzystać z Offline+:",
        section: "Offline+",
        sectionRaw: "How to use Offline+",
        steps: ["Przesuń przełącznik <strong>Offline+</strong>* w dół"],
        note: "*Przełącznik Offline+ znajduje się w górnej lewej części Kompakta.",
      },
      {
        title: "Aby przywrócić pełną funkcjonalność telefonu:",
        section: "Offline+",
        sectionRaw: "How to use Offline+",
        steps: ["Przesuń przełącznik <strong>Offline+</strong>* w górę"],
        note: "*Przełącznik Offline+ znajduje się w górnej lewej części Kompakta.",
      },
    ],
    note: "Przełącznik Offline+ znajduje się po lewej stronie Kompakta.",
  },

  // How to update Kompakt section
  "system-update": {
    image_main: publicImagePaths.how_to_update_kompakt_img_main,
    image: publicImagePaths.how_to_update_kompakt_img_main,
    articleTitle: "Jak zaktualizować MuditaOS K na Kompakcie",
    description: `Gdy dostępna jest nowa aktualizacja Kompakta, zobaczysz powiadomienie na górze ekranu Centrum sterowania. Pamiętaj, że Kompakt można zaktualizować tylko na samym urządzeniu, a nie przez Mudita Center. Kompakt musi być połączony z internetem.`,
    content: [
      {
        title: "Jak zaktualizować MuditaOS K na Kompakcie:",
        section: "Aktualizacja Kompakta",
        sectionRaw: "How to update Kompakt",
        steps: [
          "Wybierz powiadomienie o nowej aktualizacji MuditaOS K",
          "Wybierz <strong>Aktualizuj</strong>",
          "W razie potrzeby: przeczytaj, zaznacz odpowiednie pole wyboru i wybierz <strong>Zgadzam się na warunki licencji</strong>",
          "Aktualizacja zostanie automatycznie pobrana i skonfigurowana",
          "Wybierz <strong>Uruchom ponownie</strong>",
        ],
      },
    ],
  },

  // How to Sync and Backup with Mudita Center section
  "backup-restore": {
    image_main: publicImagePaths.how_to_sync_and_backup_kompakt_img_main,
    image: publicImagePaths.how_to_sync_and_backup_kompakt_img_1,
    content: [
      {
        title: "Jak utworzyć kopię zapasową Kompakta:",
        section: "Kopia zapasowa i przywracanie",
        sectionRaw: "How to Sync and Backup with Mudita Center",
        steps: [
          "Otwórz Mudita Center i podłącz urządzenie",
          "W sekcji <strong>Twój Kompakt</strong> wybierz <strong>Przegląd</strong>",
          "Kliknij <strong>Utwórz kopię zapasową</strong>",
          "Kliknij ponownie <strong>Utwórz kopię zapasową</strong> aby potwierdzić",
          "Utwórz hasło do zabezpieczenia kopii zapasowej*",
          "Kliknij <strong>Potwierdź hasło</strong>",
          "Wprowadź hasło, aby utworzyć kopię zapasową",
        ],
        note: "*Uwaga! Po potwierdzeniu hasła nie można go zmienić. Jeśli nie chcesz ustawiać hasła, kliknij <strong>Pomiń hasło</strong> aby utworzyć kopię zapasową.",
      },
      {
        title: "Jak przywrócić Kompakt z kopii zapasowej:",
        section: "Kopia zapasowa i przywracanie",
        sectionRaw: "How to Sync and Backup with Mudita Center",
        steps: [
          "Otwórz Mudita Center i podłącz urządzenie",
          "W sekcji <strong>Twój Kompakt</strong> wybierz <strong>Przegląd</strong>",
          "Kliknij <strong>Przywróć z kopii zapasowej</strong>",
          "Wybierz kopię zapasową z listy",
          "Kliknij <strong>Przywróć z kopii zapasowej</strong>",
          "Wprowadź hasło zabezpieczające kopię zapasową*",
          "Kliknij <strong>Potwierdź</strong>",
        ],
        note: "*Uwaga! Nie ma możliwości odzyskania lub zmiany hasła do kopii zapasowej. Jeśli nie ustawiono hasła, ten krok zostanie pominięty i rozpocznie się proces przywracania.",
      },
    ],
  },
  "file-transfer": {
    image_main: publicImagePaths.how_to_sync_and_backup_kompakt_img_main,
    image: publicImagePaths.how_to_sync_and_backup_kompakt_img_2,
    content: [
      {
        title: "Jak dodać zdjęcia do Kompakta:",
        section: "Kopia zapasowa i przywracanie",
        sectionRaw: "How to Sync and Backup with Mudita Center",
        steps: [
          "Otwórz Mudita Center i podłącz urządzenie",
          "W sekcji <strong>Twój Kompakt</strong> wybierz <strong>Zarządzaj plikami</strong>",
          "Kliknij <strong>Zdjęcia</strong>",
          "Kliknij <strong>Dodaj plik</strong>",
          "Wskaż i wybierz pliki zdjęć* do dodania",
          "Potwierdź przesłanie zdjęć do Kompakta",
        ],
        note: "*Jeśli dany typ pliku nie jest obsługiwany przez Kompakt, nie będzie można go wybrać.",
      },
      {
        title: "Jak dodać pliki muzyczne do Kompakta:",
        section: "Kopia zapasowa i przywracanie",
        sectionRaw: "How to Sync and Backup with Mudita Center",
        steps: [
          "Otwórz Mudita Center i podłącz urządzenie",
          "W sekcji <strong>Twój Kompakt</strong> wybierz <strong>Zarządzaj plikami</strong>",
          "Kliknij <strong>Muzyka</strong>",
          "Kliknij <strong>Dodaj plik</strong>",
          "Wskaż i wybierz pliki audio* do dodania",
          "Potwierdź przesłanie muzyki do Kompakta",
        ],
        note: "*Jeśli dany typ pliku nie jest obsługiwany przez Kompakt, nie będzie można go wybrać.",
      },
      {
        title: "Jak dodać e-booki do Kompakta:",
        section: "Kopia zapasowa i przywracanie",
        sectionRaw: "How to Sync and Backup with Mudita Center",
        steps: [
          "Otwórz Mudita Center i podłącz urządzenie",
          "W sekcji <strong>Twój Kompakt</strong> wybierz <strong>Zarządzaj plikami</strong>",
          "Kliknij <strong>E-booki</strong>",
          "Kliknij <strong>Dodaj plik</strong>",
          "Wskaż i wybierz pliki e-booków* do dodania",
          "Potwierdź przesłanie e-booków do Kompakta",
        ],
        note: "*Jeśli dany typ pliku nie jest obsługiwany przez Kompakt, nie będzie można go wybrać.",
      },
    ],
  },

  // Recorder app
  "recording-voice-recording": {
    image_main: publicImagePaths.recorder_app_img_main,
    image: publicImagePaths.recorder_app_img_1,
    articleTitle: "Jak nagrać nagranie głosowe",
    content: [
      {
        title: "Jak nagrać nagranie głosowe:",
        section: "Aplikacja Dyktafon",
        sectionRaw: "Recorder app",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Dyktafon</strong>",
          "Wybierz przycisk <strong>Nagrywaj</strong>, aby rozpocząć nagrywanie",
          "Wybierz przycisk <strong>Pauza</strong>, aby wstrzymać nagrywanie",
          "Wybierz <strong>Gotowe</strong>, aby zatrzymać nagrywanie",
          "Wybierz <strong>Nowe nagranie</strong>, aby dodać tytuł",
          "Wybierz <strong>Gotowe</strong>",
        ],
      },
    ],
  },

  "listening-voice-recording": {
    image_main: publicImagePaths.recorder_app_img_main,
    image: publicImagePaths.recorder_app_img_2,
    articleTitle: "Jak odtwarzać nagranie głosowe",
    content: [
      {
        title: "Jak odtwarzać nagranie głosowe:",
        section: "Aplikacja Dyktafon",
        sectionRaw: "Recorder app",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Dyktafon</strong>",
          "Wybierz ikonę <strong>Menu</strong>",
          "Wybierz nagranie, które chcesz odtworzyć",
          "Wybierz przycisk <strong>Odtwórz</strong>",
          "Wybierz <strong>Gotowe</strong>, aby zamknąć",
        ],
      },
    ],
  },

  "delete-voice-recording": {
    image_main: publicImagePaths.recorder_app_img_main,
    image: publicImagePaths.recorder_app_img_3,
    articleTitle: "Jak usuwać nagrania głosowe",
    description: `Możesz usuwać pojedyncze nagrania lub wiele nagrań jednocześnie.`,
    content: [
      {
        title: "Aby usunąć pojedyncze nagranie głosowe:",
        section: "Aplikacja Dyktafon",
        sectionRaw: "Recorder app",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Dyktafon</strong>",
          "Wybierz ikonę <strong>Menu</strong>",
          "Wybierz nagranie, które chcesz usunąć",
          "Wybierz ikonę <strong>Kosza</strong>",
          "Wybierz <strong>Usuń</strong>",
        ],
      },
      {
        title: "Aby usunąć wiele nagrań głosowych:",
        section: "Aplikacja Dyktafon",
        sectionRaw: "Recorder app",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Dyktafon</strong>",
          "Wybierz ikonę <strong>Menu</strong>",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Zaznacz <strong>Pola wyboru</strong> przy nagraniach, które chcesz usunąć",
          "Wybierz <strong>Usuń</strong>",
          "Ponownie wybierz <strong>Usuń</strong>",
        ],
      },
    ],
  },

  // Privacy and Security section
  "add-fingerprints": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_1,
    articleTitle: "Jak dodać odciski palców",
    description: `Przycisk włączania Kompakta jest jednocześnie czytnikiem odcisków palców, dzięki któremu możesz szybko odblokować telefon bez wpisywania kodu.`,
    content: [
      {
        title: "Aby dodać nowy odcisk palca:",
        section: "Prywatność i bezpieczeństwo",
        sectionRaw: "Privacy and Security",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Bezpieczeństwo</strong>",
          "Wybierz <strong>Zarządzaj odciskami palców</strong>",
          "Wpisz kod dostępu i wybierz strzałkę w lewo <strong>(Enter)</strong> na klawiaturze",
          "Wybierz ikonę <strong>Plus</strong>",
          "Postępuj zgodnie z instrukcjami na ekranie*",
        ],
        note: "*Upewnij się, że po każdej wibracji przykładasz do czytnika nieco inny fragment palca.",
      },
    ],
  },

  "delete-fingerprints": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_2,
    articleTitle: "Jak usunąć odciski palców",
    content: [
      {
        title: "Jak usunąć odciski palców:",
        section: "Prywatność i bezpieczeństwo",
        sectionRaw: "Privacy and Security",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Bezpieczeństwo</strong>",
          "Wybierz <strong>Zarządzaj odciskami palców</strong>",
          "Wpisz kod dostępu i wybierz strzałkę w lewo <strong>(Enter)</strong> na klawiaturze",
          "Wybierz ikonę <strong>Kosza</strong> obok odcisku palca, który chcesz usunąć",
          "Wybierz <strong>Usuń</strong>",
        ],
      },
    ],
  },

  "manage-location-sharing": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_3,
    articleTitle: "Jak zarządzać udostępnianiem lokalizacji",
    description: `Kompakt pozwala włączyć lub wyłączyć udostępnianie lokalizacji dla wszystkich aplikacji albo zarządzać tym ustawieniem osobno dla każdej z nich.`,
    content: [
      {
        title:
          "Aby włączyć lub wyłączyć udostępnianie lokalizacji dla wszystkich aplikacji:",
        section: "Prywatność i bezpieczeństwo",
        sectionRaw: "Privacy and Security",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Udostępnianie lokalizacji</strong>",
          "Wybierz <strong>przełącznik</strong>, żeby włączyć lub wyłączyć udostępnianie lokalizacji dla wszystkich aplikacji",
        ],
      },
      {
        title:
          "Aby zarządzać udostępnianiem lokalizacji dla poszczególnych aplikacji:",
        section: "Prywatność i bezpieczeństwo",
        sectionRaw: "Privacy and Security",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Udostępnianie lokalizacji</strong>",
          "Wybierz aplikację, którą chcesz skonfigurować",
          "Wybierz preferowany poziom udostępniania",
        ],
      },
    ],
  },

  "block-numbers": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_4,
    articleTitle: "Jak blokować numery",
    description: `Kompakt oferuje wiele sposobów blokowania numerów:
* Możesz zablokować wszystkie zastrzeżone lub obce numery
* Możesz ręcznie dodać numery do listy zablokowanych
* Możesz zablokować numer podczas przychodzącego połączenia`,
    content: [
      {
        title: "Jak blokować numery:",
        section: "Prywatność i bezpieczeństwo",
        sectionRaw: "Privacy and Security",
        steps: [
          "Możesz zablokować wszystkie zastrzeżone lub obce numery",
          "Możesz ręcznie dodać numery do listy zablokowanych",
          "Możesz zablokować numer podczas przychodzącego połączenia",
        ],
      },
    ],
  },

  "block-hidden-numbers": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_5,
    articleTitle: "Jak zablokować zastrzeżone lub obce numery",
    description: `Możesz zablokować wszystkie połączenia i wiadomości z zastrzeżonych numerów. Możesz też zablokować wszystkie numery, których nie zapisano w telefonie - będziesz wtedy otrzymywać połączenia i wiadomości jedynie od swoich kontaktów.`,
    content: [
      {
        title: "Aby zablokować wszystkie numery ukryte lub nierozpoznane:",
        section: "Prywatność i bezpieczeństwo",
        sectionRaw: "Privacy and Security",
        steps: [
          "Wybierz <strong>Telefon</strong>",
          "Wybierz <strong>Ostatnie</strong>",
          "Wybierz ikonę <strong>Ustawienia aplikacji</strong> w górnym pasku",
          "Wybierz <strong>Blokowanie połączeń</strong>",
          "Użyj przełączników, by zaznaczyć <strong>Blokuj ukryte numery</strong> lub <strong>Blokuj nierozpoznane numery</strong>",
        ],
      },
    ],
  },

  "add-to-blocked-list": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_6,
    articleTitle: "Jak zablokować pojedynczy numer",
    content: [
      {
        title: "Jak zablokować pojedynczy numer:",
        section: "Prywatność i bezpieczeństwo",
        sectionRaw: "Privacy and Security",
        steps: [
          "Wybierz <strong>Telefon</strong>",
          "Wybierz <strong>Ostatnie</strong>",
          "Wybierz ikonę <strong>Ustawienia aplikacji</strong> na górnym pasku",
          "Wybierz <strong>Blokowanie połączeń</strong>",
          "Wybierz <strong>Zablokowane numery</strong>",
          "Wybierz <strong>Dodaj do zablokowanych</strong> lub ikonę <strong>Plus</strong>",
          "Wprowadź numer, który chcesz zablokować",
          "Wybierz <strong>Zablokuj</strong>",
        ],
      },
    ],
  },

  "block-from-incoming-call": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_7,
    articleTitle: "Jak zablokować numer podczas przychodzącego połączenia",
    content: [
      {
        title: "Gdy dzwoni do Ciebie numer, który chcesz zablokować:",
        section: "Prywatność i bezpieczeństwo",
        sectionRaw: "Privacy and Security",
        steps: [
          "Wybierz ikonę <strong>Zablokuj</strong>",
          "Wybierz <strong>Zablokuj numer</strong>",
        ],
      },
    ],
  },

  "unblock-numbers": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_8,
    articleTitle: "Jak odblokować zablokowany numer",
    content: [
      {
        title: "Jak odblokować zablokowany numer:",
        section: "Prywatność i bezpieczeństwo",
        sectionRaw: "Privacy and Security",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Blokowanie połączeń</strong>",
          "Wybierz <strong>Zablokowane numery</strong>",
          "Wybierz ikonę <strong>Minus</strong> przy numerze, który chcesz odblokować",
        ],
      },
    ],
  },

  "stop-showing-files-usb": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_9,
    articleTitle:
      "Jak wyłączyć przeglądanie plików przy połączeniu przez USB-C",
    description: `Możesz wyłączyć dostęp do plików Kompakta przy podłączeniu go do komputera. Jest to szczególnie przydatne, gdy podłączasz telefon do cudzego komputera.`,
    content: [
      {
        title: "Aby wyłączyć wyświetlanie plików:",
        section: "Prywatność i bezpieczeństwo",
        sectionRaw: "Privacy and Security",
        steps: [
          "Podłącz Kompakt do komputera za pomocą kabla USB-C",
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Połączone urządzenia</strong>",
          "Wybierz <strong>Preferencje USB</strong>*",
          "Wybierz <strong>Bez przesyłania danych</strong>",
        ],
        note: "*Jeśli Kompakt nie jest podłączony do komputera, opcja ta nie będzie widoczna!",
      },
    ],
  },

  // Basic settings and customization section
  "change-volume-level": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_1,
    articleTitle: "Jak zmienić poziom głośności",
    description: `Istnieją dwa sposoby zmiany głównego poziomu głośności na Kompakcie. Możesz też oddzielnie ustawić poziom głośności wybranych funkcji, takich jak alarm lub dzwonek.`,
    content: [
      {
        title: "Aby ustawić główny poziom głośności przez Centrum sterowania:",
        section: "Podstawowe ustawienia i personalizacja",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Przesuń pasek głośności pod ikoną dzwonka w górę lub w dół",
        ],
      },
      {
        title: "Aby ustawić główny poziom głośności za pomocą przycisków:",
        section: "Podstawowe ustawienia i personalizacja",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Naciśnij lub przytrzymaj przycisk zwiększania głośności, aby ją podnieść",
          "Naciśnij lub przytrzymaj przycisk zmniejszania głośności, aby ją obniżyć",
        ],
      },
      {
        title: "Aby zmienić głośność dla konkretnych funkcji:",
        section: "Podstawowe ustawienia i personalizacja",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Dźwięk</strong>",
          "Użyj suwaków, aby ustawić preferowany poziom",
        ],
      },
    ],
  },

  "turn-sounds-on-off": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_2,
    articleTitle: "Jak włączyć lub wyłączyć wybrane dźwięki",
    content: [
      {
        title: "Jak włączyć lub wyłączyć wybrane dźwięki:",
        section: "Podstawowe ustawienia i personalizacja",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Dźwięk</strong>",
          "Wybierz <strong>Zaawansowane</strong>",
          "Użyj przełączników, aby włączyć lub wyłączyć:",
          "1. Dźwięki klawiatury numerycznej",
          "2. Dźwięki blokowania ekranu",
          "3. Dźwięki i wibracje podczas ładowania",
          "4. Dźwięki dotyku",
          "5. Wibracje dotyku",
        ],
      },
    ],
  },

  "change-keyboard-layout": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_3,
    articleTitle: "Jak zmienić układ klawiatury",
    description: ``,
    content: [
      {
        title: "Jak zmienić układ klawiatury:",
        section: "Podstawowe ustawienia i personalizacja",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>System</strong>",
          "Wybierz <strong>Język systemu i klawiatura</strong>",
          "Wybierz <strong>Ustawienia klawiatury</strong>",
          "Wybierz <strong>Języki i style</strong>",
          "Wybierz <strong>Niestandardowe metody wprowadzania</strong>",
          "Wybierz ikonę <strong>Plus</strong>",
          "Wybierz <strong>Układ</strong>",
          "Wybierz układ, który chcesz dodać",
          "Wybierz ikonę <strong>Strzałki wstecz</strong>",
          "Wybierz <strong>Dodaj</strong>",
        ],
        note: "Ta funkcja ma złożony interfejs użytkownika i może być trudna w nawigacji.",
      },
    ],
  },

  "change-system-language": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_4,
    articleTitle: "Jak zmienić język systemu",
    content: [
      {
        title: "Jak zmienić język systemu:",
        section: "Podstawowe ustawienia i personalizacja",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>System</strong>",
          "Wybierz <strong>Język i klawiatura</strong>",
          "Wybierz <strong>Język systemu</strong>",
          "Wybierz język, którego chcesz użyć",
          "Wybierz <strong>Potwierdź</strong>",
        ],
      },
    ],
  },

  "hide-unhide-app-icons": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_5,
    articleTitle: "Jak ukryć lub przywrócić ikony aplikacji",
    description: `Ikony niektórych aplikacji, takich jak pogoda, kalendarz czy alarm, są domyślnie ukryte. Jeśli wolisz, możesz je przywrócić.`,
    content: [
      {
        title: "Aby ukryć lub odkryć aplikacje:",
        section: "Podstawowe ustawienia i personalizacja",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Układ aplikacji</strong>",
          "Użyj <strong>przełączników</strong>, aby pokazać lub ukryć aplikacje*",
          "Wybierz ikonę <strong>Strzałki wstecz</strong>, aby zapisać zmiany i wyjść",
        ],
        note: "*Aby zobaczyć, jak będzie wyglądał ekran aplikacji, wybierz <strong>Podgląd</strong>",
      },
    ],
  },

  "change-screen-timeout": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_6,
    articleTitle: "Jak zmienić opóźnienie wygaszania ekranu",
    description: `Aby oszczędzać energię i chronić telefon, ekran Kompakta automatycznie przechodzi w stan wygaszenia.`,
    content: [
      {
        title: "Aby dostosować opóźnienie wygaszania ekranu:",
        section: "Podstawowe ustawienia i personalizacja",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Ekran</strong>",
          "Wybierz <strong>Wygaszanie ekranu</strong>",
          "Wybierz preferowany czas",
        ],
      },
    ],
  },

  "silent-mode": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_7,
    articleTitle: "Jak przełączyć Kompakt w tryb cichy",
    description: `Istnieją dwa główne sposoby przełączenia Kompakta w tryb cichy.`,
    content: [
      {
        title: "Aby ustawić tryb cichy przez Centrum sterowania:",
        section: "Podstawowe ustawienia i personalizacja",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Dzwonka</strong> lub przesuń pasek głośności całkowicie w dół",
        ],
      },
      {
        title: "Aby ustawić tryb cichy za pomocą przycisków głośności:",
        section: "Podstawowe ustawienia i personalizacja",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Przytrzymaj przycisk zmniejszania głośności, aż pasek głośności przesunie się całkowicie w dół",
        ],
      },
    ],
  },

  // Connectivity section
  "airplane-mode": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_1,
    articleTitle: "Jak włączyć lub wyłączyć tryb samolotowy",
    description: `Tryb samolotowy wyłącza antenę i Wi-Fi, ale nadal pozwala włączyć Bluetooth.`,
    content: [
      {
        title: "Aby włączyć lub wyłączyć tryb samolotowy:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Samolot</strong>",
        ],
      },
    ],
  },

  "connect-wifi": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_2,
    articleTitle: "Jak połączyć się z siecią Wi-Fi",
    content: [
      {
        title: "Jak połączyć się z siecią Wi-Fi:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Sieć i internet</strong>",
          "Wybierz <strong>Wi-Fi</strong>",
          "Wybierz sieć Wi-Fi, do której chcesz się połączyć",
          "Wprowadź hasło do sieci Wi-Fi",
          "Wybierz <strong>Połącz</strong>",
        ],
      },
    ],
  },

  "connect-bluetooth": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_3,
    articleTitle: "Jak łączyć urządzenia przez Bluetooth",
    description: `Przed rozpoczęciem upewnij się, że urządzenie, które chcesz połączyć, ma włączony Bluetooth i jest wykrywalne.`,
    content: [
      {
        title: "Aby połączyć urządzenie:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Podłączone urządzenia</strong>",
          "Wybierz <strong>Sparuj nowe urządzenia</strong>",
          "Wybierz urządzenie, z którym chcesz się sparować, z listy",
          "Wybierz <strong>Sparuj</strong>",
        ],
        note: 'Jeśli pojawi się powiadomienie "Bluetooth jest włączony", zamknij je, wybierając ikonę X.',
      },
      {
        title:
          "Możesz także włączać i wyłączać Bluetooth z Centrum sterowania:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Bluetooth</strong>",
        ],
      },
    ],
  },

  "create-hotspot": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_4,
    articleTitle: "Jak utworzyć hotspot",
    description: `Hotspoty pozwalają innym urządzeniom korzystać z Wi-Fi lub danych Kompakta, gdy są podłączone.`,
    content: [
      {
        title: "Aby utworzyć hotspot:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Sieć i Internet</strong>",
          "Wybierz <strong>Hotspot i tethering</strong>",
          "Wybierz <strong>Hotspot Wi-Fi</strong>",
          "Możesz edytować nazwę, hasło* i ustawienia bezpieczeństwa hotspotu",
          "Aby włączyć hotspot, wybierz <strong>przełącznik</strong> w górnej części ekranu",
        ],
        note: "*Hasło musi mieć co najmniej 8 znaków",
      },
      {
        title: "Możesz także włączać i wyłączać hotspot z Centrum sterowania:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz <strong>ikonę Hotspot</strong>, która znajduje się nad ikoną Samolotu",
        ],
      },
    ],
  },

  "share-wifi-password": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_5,
    articleTitle: "Jak udostępnić hasło Wi-Fi",
    content: [
      {
        title: "Jak udostępnić hasło Wi-Fi:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Sieć i internet</strong>",
          "Wybierz <strong>Wi-Fi</strong>",
          "Wybierz sieć Wi-Fi, do której jesteś podłączony",
          "Wybierz <strong>Udostępnij</strong>",
          "Przyłóż palec do przycisku odblokowywania, aby zeskanować odcisk palca lub wybierz <strong>Użyj PIN-u</strong> i wprowadź PIN",
          "Zeskanuj kod QR za pomocą drugiego urządzenia lub przepisz ręcznie hasło Wi-Fi",
        ],
      },
    ],
  },

  "add-esim": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_6,
    articleTitle: "Jak dodać eSIM",
    description: `Przed rozpoczęciem upewnij się, że Kompakt jest połączony z internetem i znajduje się w trybie eSIM.`,
    content: [
      {
        title: "Aby dodać eSIM:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Sieć i internet</strong>",
          "Wybierz <strong>Karty SIM</strong>",
          "Wybierz <strong>Dodaj kartę eSIM</strong>",
          "Wybierz <strong>Kontynuuj</strong>",
          "Zeskanuj kod QR lub wybierz <strong>Wprowadź kod ręcznie</strong> i wpisz kod aktywacyjny",
          "Przeczytaj zasady profilu i wybierz <strong>Akceptuję</strong>, jeśli się zgadzasz",
          "Wybierz <strong>Dodaj ten eSIM</strong>*",
        ],
        note: "*Jeśli chcesz od razu aktywować eSIM, zaznacz pole wyboru (Kompakt uruchomi się ponownie).",
      },
    ],
  },

  "switch-sim-esim": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_7,
    articleTitle: "Jak przełączyć się między trybem SIM 2 a trybem eSIM",
    description: `Dowiedz się, jak zainstalować eSIM.`,
    content: [
      {
        title: "Aby przełączyć tryb:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Sieć i internet</strong>",
          "Wybierz <strong>Karty SIM</strong>",
          "Wybierz <strong>Zmień na kartę SIM 2</strong> lub <strong>Zmień na kartę eSIM</strong>",
          "Wybierz <strong>Zmień</strong>. Kompakt uruchomi się ponownie.",
        ],
      },
    ],
  },

  "data-downloads": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_8,
    articleTitle:
      "Jak włączyć lub wyłączyć pobieranie z użyciem danych mobilnych",
    description: `Jeśli wyłączysz pobieranie z użyciem danych mobilnych, Kompakt będzie potrzebował połączenia Wi-Fi, aby pobierać dane. Przydatne, gdy masz ograniczony pakiet danych lub wysokie koszty transmisji.`,
    content: [
      {
        title: "Aby zarządzać danymi mobilnymi:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Sieć i internet</strong>",
          "Wybierz <strong>Sieć komórkowa</strong>",
          "Użyj przełącznika <strong>Dane mobilne</strong>, aby włączyć lub wyłączyć korzystanie z danych",
        ],
      },
    ],
  },

  "allow-stop-roaming": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_9,
    articleTitle: "Jak włączyć lub wyłączyć roaming",
    description: `Roaming pozwala na korzystanie z urządzenia poza granicami kraju. Operator sieci może naliczać dodatkowe opłaty. Zawsze sprawdź warunki u swojego operatora przed korzystaniem z roamingu!`,
    content: [
      {
        title: "Aby włączyć lub wyłączyć roaming:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Sieć i internet</strong>",
          "Wybierz <strong>Sieć komórkowa</strong>",
          "Użyj przełącznika <strong>Roaming</strong>, aby włączyć lub wyłączyć roaming",
        ],
      },
    ],
  },

  "use-offline-plus": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_10,
    articleTitle: "Jak korzystać z trybu Offline+",
    description: `Offline+ to coś więcej niż tryb samolotowy. Włącza antenę, mikrofony, kamerę, Wi-Fi i Bluetooth.`,
    content: [
      {
        title: "Aby włączyć Offline+:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: ["Przesuń przełącznik <strong>Offline+</strong> w dół"],
      },
      {
        title: "Aby przywrócić pełną funkcjonalność telefonu:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: ["Przesuń przełącznik <strong>Offline+</strong> w górę"],
      },
    ],
    note: "Przełącznik Offline+ znajduje się po lewej stronie Kompakta.",
  },

  "insert-physical-sim": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_11,
    articleTitle: "Jak włożyć fizyczną kartę SIM",
    content: [
      {
        title: "Jak włożyć fizyczną kartę SIM:",
        section: "Łączność",
        sectionRaw: "Connectivity",
        steps: [
          "Włóż <strong>kluczyk SIM</strong> do okrągłego otworu",
          "Całkowicie wyciągnij <strong>tackę SIM</strong>",
          "Włóż <strong>kartę SIM</strong> do <strong>tacki SIM</strong> – złotą stroną SIM skierowaną w dół",
          "Włóż <strong>tackę SIM</strong> do Kompakta",
        ],
      },
    ],
  },

  // Troubleshooting section
  "find-phone-number": {
    image_main: publicImagePaths.troubleshooting_img_main,
    image: publicImagePaths.troubleshooting_img_1,
    articleTitle: "Jak sprawdzić swój numer telefonu",
    description: `Możesz sprawdzić numery telefonów przypisane do każdej zainstalowanej karty SIM w ekranie statusu SIM.`,
    content: [
      {
        title: "Aby sprawdzić numer telefonu:",
        section: "Rozwiązywanie problemów",
        sectionRaw: "Troubleshooting",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>O urządzeniu</strong>",
          "Wybierz <strong>Stan karty SIM (gniazdo SIM 1 lub 2)</strong> dla karty SIM, którą chcesz sprawdzić",
        ],
      },
    ],
  },

  "factory-reset": {
    image_main: publicImagePaths.troubleshooting_img_main,
    image: publicImagePaths.troubleshooting_img_2,
    articleTitle: "Jak przywrócić ustawienia fabryczne urządzenia",
    description: `Uwaga! To usunie wszystkie Twoje dane z urządzenia! Wersja MuditaOS K pozostanie taka sama.`,
    content: [
      {
        title: "Aby przywrócić ustawienia fabryczne:",
        section: "Rozwiązywanie problemów",
        sectionRaw: "Troubleshooting",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>System</strong>",
          "Wybierz <strong>Reset Options</strong>",
          "Wybierz ponownie <strong>Przywracanie ustawień fabrycznych</strong>",
          "Jeśli jesteś pewien, że chcesz usunąć wszystkie dane, wybierz jeszcze raz <strong>Przywracanie ustawień fabrycznych</strong>",
          "Kompakt uruchomi się ponownie i będzie gotowy do ponownej konfiguracji.",
        ],
      },
    ],
  },

  "os-update-fails": {
    image_main: publicImagePaths.troubleshooting_img_main,
    image: publicImagePaths.troubleshooting_img_3,
    articleTitle:
      "Co zrobić, gdy aktualizacja systemu operacyjnego się nie powiedzie",
    description: `Jeśli aktualizacja nie powiedzie się, możesz spróbować kilku rzeczy. Przywrócenie ustawień fabrycznych to ostateczność!`,
    content: [
      {
        title:
          "Co zrobić, gdy aktualizacja systemu operacyjnego się nie powiedzie:",
        section: "Rozwiązywanie problemów",
        sectionRaw: "Troubleshooting",
        steps: [
          "Ręcznie sprawdź dostępność aktualizacji i spróbuj ponownie",
          "Upewnij się, że masz stabilne połączenie internetowe",
          "Jeśli nie masz Wi-Fi, sprawdź, czy pobieranie z wykorzystaniem danych komórkowych jest włączone",
          "Uruchom urządzenie ponownie",
          "W ostateczności: przywróć ustawienia fabryczne",
          "Jeśli żadne z powyższych nie rozwiąże problemu, skontaktuj się z obsługą klienta.",
        ],
      },
    ],
  },

  "files-not-showing-usb": {
    image_main: publicImagePaths.troubleshooting_img_main,
    image: publicImagePaths.troubleshooting_img_4,
    articleTitle:
      "Co zrobić, gdy pliki nie wyświetlają się po podłączeniu Kompakta przez USB-C",
    description: `Jeśli podłączysz Kompakt do komputera, ale nie widzisz swoich plików, musisz włączyć przesyłanie plików.`,
    content: [
      {
        title: "Aby włączyć przesyłanie plików:",
        section: "Rozwiązywanie problemów",
        sectionRaw: "Troubleshooting",
        steps: [
          "Podłącz Kompakt do komputera za pomocą kabla USB-C",
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Połączone urządzenia</strong>",
          "Wybierz <strong>Preferencje USB</strong>*",
          "Wybierz <strong>Przesyłanie plików</strong>",
        ],
        note: "*Jeśli Kompakt nie jest podłączony do komputera, ta opcja nie będzie widoczna!",
      },
    ],
  },

  // Alarm app section
  "create-alarm": {
    image_main: publicImagePaths.alarm_app_img_main,
    image: publicImagePaths.alarm_app_img_1,
    articleTitle: "Jak utworzyć alarm",
    content: [
      {
        title: "Aby utworzyć pierwszy alarm:",
        section: "Aplikacja Budzik",
        sectionRaw: "Alarm app",
        steps: [
          "Wybierz <strong>zegar</strong> na ekranie głównym*",
          "Wybierz <strong>Utwórz alarm</strong>",
          "Możesz edytować nazwę, dźwięk oraz dni powtarzania",
          "Wybierz <strong>Utwórz</strong>",
        ],
        note: "*Możesz także odkryć ikonę aplikacji, wybierając <strong>Aplikacje</strong> > <strong>Alarm</strong>",
      },
      {
        title: "Aby dodać kolejne alarmy:",
        section: "Aplikacja Budzik",
        sectionRaw: "Alarm app",
        steps: [
          "Wybierz <strong>zegar</strong> na ekranie głównym*",
          "Wybierz ikonę <strong>Plus</strong>",
          "Możesz edytować nazwę, dźwięk oraz dni powtarzania",
          "Wybierz <strong>Utwórz</strong>",
        ],
        note: "*Możesz także odkryć ikonę aplikacji, wybierając <strong>Aplikacje</strong> > <strong>Alarm</strong>",
      },
    ],
  },

  "delete-contacts": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_4,
    articleTitle: "Jak usunąć kontakt na Kompakcie",
    content: [
      {
        title: "Jak usunąć kontakt na Kompakcie",
        section: "Zarządzanie kontaktami",
        sectionRaw: "Managing contacts",
        steps: [
          "Wybierz <strong>Telefon</strong>",
          "Wybierz <strong>Kontakty</strong>",
          "Wybierz kontakt, który chcesz usunąć",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Wybierz ikonę <strong>Kosza</strong>",
          "Wybierz <strong>Usuń kontakt</strong>",
        ],
      },
    ],
  },

  "import-contacts-outlook": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_5,
    articleTitle: "Jak zaimportować kontakty z Outlooka",
    content: [
      {
        title: "Jak zaimportować kontakty z Outlooka:",
        section: "Zarządzanie kontaktami",
        sectionRaw: "Managing contacts",
        steps: [
          "Otwórz aplikację Mudita Center na komputerze i podłącz Mudita Kompakt",
          "W sekcji <strong>Twój Kompakt</strong> > Kliknij <strong>Kontakty</strong>",
          "Kliknij <strong>Importuj kontakty</strong>",
          "Kliknij <strong>Outlook</strong>",
          "Zaloguj się na swoje konto <strong>Outlook</strong>",
          "Zaznacz kontakty, które chcesz zaimportować, lub wybierz <strong>Wszystkie kontakty</strong>",
          "Kliknij <strong>Importuj wybrane kontakty</strong>, aby przesłać kontakty na telefon*",
        ],
        note: "*Ważne - nie odłączaj telefonu podczas importowania.",
      },
    ],
  },

  "import-contacts-google": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_6,
    articleTitle: "Jak importować kontakty z Google",
    content: [
      {
        title: "Jak importować kontakty z Google:",
        section: "Zarządzanie kontaktami",
        sectionRaw: "Managing contacts",
        steps: [
          "Otwórz aplikację Mudita Center na komputerze i podłącz Mudita Kompakt",
          "W sekcji <strong>Twój Kompakt</strong> > Kliknij <strong>Kontakty</strong>",
          "Kliknij <strong>Importuj kontakty</strong>",
          "Kliknij <strong>Google</strong>",
          "Zaloguj się na swoje konto Google",
          "Zaznacz kontakty, które chcesz zaimportować, lub wybierz <strong>Wszystkie kontakty</strong>",
          "Kliknij <strong>Importuj wybrane kontakty</strong>, aby przesłać kontakty na telefon*",
        ],
        note: "*Ważne - nie odłączaj telefonu podczas importowania.",
      },
    ],
  },

  "import-contacts-csv-vcard": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_7,
    articleTitle: "Jak importować kontakty z pliku CSV lub vCard",
    description:
      "Zanim zaczniesz, musisz utworzyć plik CSV za pomocą Outlook, utworzyć vCard za pomocą konta Google lub utworzyć vCard (plik VCF) za pomocą iCloud.",
    content: [
      {
        title: "Jak importować kontakty z pliku CSV lub vCard:",
        section: "Zarządzanie kontaktami",
        sectionRaw: "Managing contacts",
        steps: [
          "Otwórz aplikację Mudita Center na komputerze i podłącz Mudita Kompakt",
          "W sekcji <strong>Twój Kompakt</strong> > Kliknij <strong>Kontakty</strong>",
          "Kliknij <strong>Importuj kontakty</strong>",
          "Kliknij <strong>Prześlij plik CSV lub vCard</strong>",
          "Wybierz plik CSV lub vCard z komputera",
          "Zaznacz kontakty, które chcesz zaimportować, lub wybierz <strong>Wszystkie kontakty</strong>",
          "Kliknij <strong>Importuj wybrane kontakty</strong>, aby przesłać kontakty na telefon*",
        ],
        note: "*Ważne - nie odłączaj telefonu podczas importowania.",
      },
    ],
  },

  "create-vcard-icloud": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_8,
    articleTitle: "Jak utworzyć vCard (plik VCF) za pomocą iCloud",
    content: [
      {
        title: "Jak utworzyć vCard (plik VCF) za pomocą iCloud:",
        section: "Zarządzanie kontaktami",
        sectionRaw: "Managing contacts",
        steps: [
          "Na komputerze zaloguj się do konta iCloud za pomocą Apple ID",
          "Kliknij <strong>Kontakty</strong>",
          "Wybierz kontakty do eksportu za pomocą <strong>ctrl + klik</strong> lub <strong>shift + klik</strong>*",
          "Kliknij ikonę <strong>Eksportuj</strong>",
          "Kliknij <strong>Eksportuj vCard</strong>",
          "Plik vCard (VCF) powinien pojawić się w folderze Pobrane",
        ],
        note: "*Aby szybko wybrać wszystkie kontakty, kliknij ikonę 3 kropek w kółku > kliknij Zaznacz wszystko",
      },
    ],
  },

  "create-csv-vcard-google": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_9,
    articleTitle: "Jak utworzyć plik CSV lub vCard za pomocą konta Google",
    content: [
      {
        title: "Jak utworzyć plik CSV lub vCard za pomocą konta Google:",
        section: "Zarządzanie kontaktami",
        sectionRaw: "Managing contacts",
        steps: [
          "Na komputerze zaloguj się do konta Gmail za pomocą Google ID",
          "Kliknij ikonę <strong>Siatki</strong>, aby pokazać listę aplikacji",
          "Kliknij <strong>Kontakty</strong>",
          "Wybierz kontakty do eksportu",
          "Kliknij ikonę <strong>3 kropek</strong>",
          "Kliknij <strong>Eksportuj</strong>",
          "Wybierz, w jaki sposób chcesz eksportować kontakty - CSV lub vCard",
          "Kliknij <strong>Eksportuj</strong>",
          "Plik CSV lub vCard powinien pojawić się w folderze Pobrane",
        ],
        note: "*Aby szybko wybrać wszystkie kontakty, kliknij ikonę <strong>strzałki w dół</strong> > kliknij <strong>Wszystkie</strong>",
      },
    ],
  },

  "create-csv-outlook": {
    articleTitle: "Jak utworzyć plik CSV za pomocą Outlook",
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_10,
    content: [
      {
        title: "Jak utworzyć plik CSV za pomocą Outlook:",
        section: "Zarządzanie kontaktami",
        sectionRaw: "Managing contacts",
        steps: [
          "Na komputerze zaloguj się do konta Outlook za pomocą Microsoft ID",
          "Kliknij ikonę <strong>Osoby</strong>",
          "Kliknij <strong>Zarządzaj kontaktami</strong>",
          "Kliknij <strong>Eksportuj</strong>",
          "Kliknij <strong>Eksportuj</strong>",
          "Plik CSV powinien pojawić się w folderze Pobrane",
        ],
      },
    ],
  },

  "delete-contacts-mudita-center": {
    articleTitle: "Jak usuwać kontakty za pomocą Mudita Center",
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_11,
    content: [
      {
        title: "Jak usuwać kontakty za pomocą Mudita Center:",
        section: "Zarządzanie kontaktami",
        sectionRaw: "Managing contacts",
        steps: [
          "Otwórz Mudita Center i podłącz urządzenie",
          "W sekcji <strong>Twój Kompakt</strong> > Kliknij <strong>Kontakty</strong>",
          "Najedź kursorem myszy na kontakt, który chcesz usunąć",
          "Kliknij <strong>Pole wyboru</strong>, aby wybrać kontakt*",
          "Wybierz inne kontakty, które chcesz usunąć",
          "Kliknij <strong>Usuń</strong>",
          "Kliknij <strong>Usuń</strong>",
        ],
        note: "*Aby wybrać wszystkie, kliknij ikonę <strong>minus</strong> w górnej części ekranu",
      },
    ],
  },

  "edit-alarm": {
    image_main: publicImagePaths.alarm_app_img_main,
    image: publicImagePaths.alarm_app_img_2,
    articleTitle: "Jak edytować alarm",
    content: [
      {
        title: "Jak edytować alarm",
        section: "Aplikacja Alarm",
        sectionRaw: "Alarm app",
        steps: [
          "Wybierz <strong>zegarek</strong> na ekranie głównym*",
          "Wybierz alarm, który chcesz edytować",
          "Edytuj godzinę za pomocą <strong>strzałek góra/dół</strong> lub klawiatury numerycznej",
          "Możesz edytować nazwę, dźwięk oraz dni, w które ma się powtarzać",
          "Wybierz <strong>Zapisz</strong>",
        ],
        note: "*Możesz także odkryć ikonę aplikacji, aby uzyskać do niej dostęp poprzez wybór <strong>Aplikacje</strong>, a następnie <strong>Alarm</strong>",
      },
    ],
  },

  "delete-alarm": {
    image_main: publicImagePaths.alarm_app_img_main,
    image: publicImagePaths.alarm_app_img_3,
    articleTitle: "Jak usunąć alarm",
    content: [
      {
        title: "Jak usunąć alarm",
        section: "Aplikacja Alarm",
        sectionRaw: "Alarm app",
        steps: [
          "Wybierz <strong>zegarek</strong> na ekranie głównym*",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Wybierz ikonę <strong>Kosza</strong>",
        ],
        note: "*Możesz także odkryć ikonę aplikacji, aby uzyskać do niej dostęp poprzez wybór <strong>Aplikacje</strong>, a następnie <strong>Alarm</strong>",
      },
    ],
  },

  "snooze-alarm": {
    image_main: publicImagePaths.alarm_app_img_main,
    image: publicImagePaths.alarm_app_img_4,
    articleTitle: "Jak włączyć drzemkę",
    description: `Funkcja drzemki ma ustawiony stały czas 5 minut i nie uruchamia się automatycznie.`,
    content: [
      {
        title: "Aby włączyć drzemkę:",
        section: "Aplikacja Alarm",
        sectionRaw: "Alarm app",
        steps: [
          "Poczekaj, aż zadzwoni alarm",
          "Wybierz <strong>Drzemka</strong>",
        ],
      },
    ],
  },

  // Messaging section
  "send-sms-to-contact": {
    image_main: publicImagePaths.messaging_img_main,
    image: publicImagePaths.messaging_img_1,
    articleTitle: "Jak wysyłać wiadomości SMS do kontaktu",
    description: `Możesz również wysyłać wiadomości SMS na nowy numer.`,
    content: [
      {
        title: "Aby wysłać wiadomość SMS do kontaktu:",
        section: "Wiadomości",
        sectionRaw: "Messaging",
        steps: [
          "Wybierz <strong>SMS</strong>",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Wybierz kontakt, do którego chcesz napisać",
          "Wpisz treść wiadomości*",
          "Wybierz ikonę <strong>Wyślij</strong>",
        ],
        note: "*Jeśli klawiatura się nie pojawi automatycznie, dotknij migającego kursora w polu tekstowym",
      },
    ],
  },

  "send-sms-to-new-number": {
    image_main: publicImagePaths.messaging_img_main,
    image: publicImagePaths.messaging_img_2,
    articleTitle: "Jak wysyłać wiadomości SMS na nowy numer",
    description: `Możesz również wysyłać wiadomości SMS do kontaktu.`,
    content: [
      {
        title: "Aby wysłać wiadomość SMS na nowy numer:",
        section: "Wiadomości",
        sectionRaw: "Messaging",
        steps: [
          "Wybierz <strong>SMS</strong>",
          "Wybierz ikonę <strong>Plusa</strong>",
          "Wprowadź numer telefonu",
          "Wybierz <strong>Wyślij do: xxxxxxxxxx</strong>",
          "Wpisz treść wiadomości*",
          "Wybierz ikonę <strong>Wyślij</strong>",
        ],
        note: "*Jeśli klawiatura się nie pojawia automatycznie, dotknij migającego kursora w polu tekstowym",
      },
    ],
  },

  "send-mms-to-contact": {
    image_main: publicImagePaths.messaging_img_main,
    image: publicImagePaths.messaging_img_3,
    articleTitle: "Jak wysyłać wiadomości MMS do kontaktu",
    description: `Możesz również wysyłać wiadomości MMS na nowy numer.`,
    content: [
      {
        title: "Aby wysłać wiadomość MMS do kontaktu:",
        section: "Wiadomości",
        sectionRaw: "Messaging",
        steps: [
          "Wybierz <strong>SMS</strong>",
          "Wybierz ikonę <strong>Plusa</strong>",
          "Wybierz kontakt, do którego chcesz napisać",
          "Wybierz ikonę <strong>Obrazu</strong>",
          "Wybierz obraz, który chcesz wysłać",
          "Wybierz <strong>Wyślij</strong>",
        ],
      },
    ],
  },

  "send-mms-to-new-number": {
    image_main: publicImagePaths.messaging_img_main,
    image: publicImagePaths.messaging_img_4,
    articleTitle: "Jak wysyłać wiadomości MMS na nowy numer",
    description: `Możesz również wysyłać wiadomości MMS do kontaktu.`,
    content: [
      {
        title: "Aby wysłać wiadomość MMS na nowy numer:",
        section: "Wiadomości",
        sectionRaw: "Messaging",
        steps: [
          "Wybierz <strong>SMS</strong>",
          "Wybierz ikonę <strong>Plusa</strong>",
          "Wprowadź numer telefonu",
          "Wybierz <strong>wyślij do: xxxxxxxxxx</strong>",
          "Wybierz ikonę <strong>Obrazu</strong>",
          "Wybierz obraz, który chcesz wysłać",
          "Wybierz <strong>Wyślij</strong>",
        ],
      },
    ],
  },

  "delete-conversations": {
    image_main: publicImagePaths.messaging_img_main,
    image: publicImagePaths.messaging_img_5,
    articleTitle: "Jak usunąć rozmowy",
    content: [
      {
        title: "Jak usunąć rozmowy",
        section: "Wiadomości",
        sectionRaw: "Messaging",
        steps: [
          "Wybierz <strong>SMS</strong>",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Wybierz rozmowy, które chcesz usunąć",
          "Wybierz <strong>Usuń</strong>",
          "Wybierz ponownie <strong>Usuń</strong>",
        ],
      },
    ],
  },

  // Camera app section
  "take-photos-camera": {
    image_main: publicImagePaths.camera_app_img_main,
    image: publicImagePaths.camera_app_img_1,
    articleTitle: "Jak zrobić zdjęcie",
    content: [
      {
        title: "Jak zrobić zdjęcie",
        section: "Aplikacja Aparatu",
        sectionRaw: "Camera app",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Aparat</strong>",
          "Skieruj aparat na obiekt",
          "Wybierz przycisk <strong>Zrób zdjęcie</strong>*",
        ],
        note: "*Ze względu na ekran E Ink®, trzymaj telefon nieruchomo chwilę dłużej niż w przypadku standardowych smartfonów",
      },
    ],
  },

  "view-photos-camera": {
    image_main: publicImagePaths.camera_app_img_main,
    image: publicImagePaths.camera_app_img_2,
    articleTitle: "Jak przeglądać zdjęcia",
    description: `Na Kompakcie zdjęcia można oglądać wyłącznie w skali szarości. Po przeniesieniu ich do komputera zobaczysz je w pełnym kolorze.`,
    content: [
      {
        title: "Jak przeglądać zdjęcia",
        section: "Aplikacja Aparatu",
        sectionRaw: "Camera app",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Aparat</strong>",
          "Wybierz ikonę <strong>Obrazu</strong>",
          "Wybierz <strong>zdjęcie</strong>, które chcesz obejrzeć",
        ],
      },
    ],
  },

  "take-screenshot": {
    image_main: publicImagePaths.camera_app_img_main,
    image: publicImagePaths.camera_app_img_3,
    articleTitle: "Jak zrobić zrzut ekranu",
    content: [
      {
        title: "Jak zrobić zrzut ekranu",
        section: "Aplikacja Aparatu",
        sectionRaw: "Camera app",
        steps: [
          "Jednocześnie naciśnij przycisk <strong>Zasilania</strong> i <strong>Zmniejszania głośności</strong>*",
        ],
        note: "*Nie pojawi się żadne potwierdzenie wykonania zrzutu ekranu, ale będzie on widoczny w galerii zdjęć",
      },
    ],
  },

  "transfer-photos": {
    image_main: publicImagePaths.camera_app_img_main,
    image: publicImagePaths.camera_app_img_4,
    articleTitle: "Jak przenieść zdjęcia na komputer",
    description: `Zdjęcia można przesyłać na komputer za pomocą Eksploratora plików Windows lub przez wiadomości MMS.`,
    content: [
      {
        title: "Aby przenieść zdjęcia za pomocą Windows:",
        section: "Aplikacja Aparatu",
        sectionRaw: "Camera app",
        steps: [
          "Podłącz Kompakt do komputera za pomocą kabla USB-C*",
          "Otwórz folder z plikami Kompakta",
          "Otwórz folder DCIM**",
          "Zaznacz zdjęcia, które chcesz przenieść, i skopiuj je na komputer",
        ],
        note: "*Jeśli pliki się nie wyświetlają, włącz przesyłanie danych\n**Zrzuty ekranu znajdują się w folderze Pictures",
      },
    ],
  },

  // Notes app section
  "create-notes": {
    image_main: publicImagePaths.notes_img_main,
    image: publicImagePaths.notes_img_1,
    articleTitle: "Jak tworzyć notatki",
    content: [
      {
        title: "Jak tworzyć notatki",
        section: "Aplikacja Notatek",
        sectionRaw: "Notes app",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Notatki</strong>",
          "Wybierz ikonę <strong>Plus</strong>*",
          "Wpisz tytuł notatki (maks. 54 znaki)",
          "Wybierz <strong>Enter</strong> na klawiaturze",
          "Wpisz treść notatki",
          "Wybierz <strong>Gotowe</strong>",
        ],
        note: "*Jeśli to Twoja pierwsza notatka, wybierz <strong>Utwórz nową notatkę</strong>",
      },
    ],
  },

  "delete-notes": {
    image_main: publicImagePaths.notes_img_main,
    image: publicImagePaths.notes_img_2,
    articleTitle: "Jak usuwać notatki",
    content: [
      {
        title: "Jak usuwać notatki",
        section: "Aplikacja Notatek",
        sectionRaw: "Notes app",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Notatki</strong>",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Zaznacz <strong>Pole wyboru</strong> obok notatki lub notatek, które chcesz usunąć",
          "Wybierz <strong>Usuń</strong>",
          "Ponownie wybierz <strong>Usuń</strong>",
        ],
      },
    ],
  },

  // Maps app section
  "download-map": {
    image_main: publicImagePaths.maps_app_img_main,
    image: publicImagePaths.maps_app_img_1,
    articleTitle: "Jak pobrać mapę",
    description: `Aby wyświetlić region lub kraj w aplikacji Mapy, musisz najpierw pobrać odpowiednią mapę. Wymagane jest połączenie z internetem. Po pobraniu mapy możesz korzystać z niej offline.`,
    content: [
      {
        title: "Aby pobrać mapę:",
        section: "Aplikacja Map",
        sectionRaw: "Maps app",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Mapy</strong> > wybierz <strong>Kontynuuj</strong>*",
          "Wybierz ikonę <strong>Menu</strong>",
          "Wybierz <strong>Zarządzaj mapami</strong>",
          "Wybierz ikonę <strong>Szukaj</strong>**",
          "Wpisz nazwę kraju lub regionu",
          "Wybierz ikonę <strong>Pobierania</strong>",
        ],
        note: "*Tylko przy pierwszym uruchomieniu aplikacji Mapy\n**Możesz też wybrać <strong>Wszystkie mapy</strong> i wskazać interesujący Cię region",
      },
    ],
  },

  "delete-map": {
    image_main: publicImagePaths.maps_app_img_main,
    image: publicImagePaths.maps_app_img_2,
    articleTitle: "Jak usunąć mapę",
    content: [
      {
        title: "Jak usunąć mapę",
        section: "Aplikacja Map",
        sectionRaw: "Maps app",
        steps: [
          "Wybierz <strong>Aplikacje</strong>",
          "Wybierz <strong>Mapy</strong>",
          "Wybierz ikonę <strong>Menu</strong>",
          "Wybierz <strong>Zarządzaj mapami</strong>",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Wybierz ikonę <strong>Kosza</strong> obok mapy, którą chcesz usunąć",
          "Wybierz <strong>Usuń mapę</strong>",
        ],
      },
    ],
  },

  // Weather app section
  "open-weather-app": {
    image_main: publicImagePaths.weather_app_img_main,
    image: publicImagePaths.weather_app_img_1,
    articleTitle: "Jak otworzyć Pogodę",
    content: [
      {
        title: "Jak otworzyć Pogodę",
        section: "Aplikacja Pogody",
        sectionRaw: "Weather app",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz widget <strong>Pogoda</strong>",
        ],
        note: "*Możesz także odkryć ikonę aplikacji i otwierać ją, wybierając <strong>Aplikacje</strong> > <strong>Pogoda</strong>",
      },
    ],
  },

  "change-weather-default-location": {
    image_main: publicImagePaths.weather_app_img_main,
    image: publicImagePaths.weather_app_img_2,
    articleTitle: "Jak zmienić domyślną lokalizację",
    content: [
      {
        title: "Jak zmienić domyślną lokalizację",
        section: "Aplikacja Pogody",
        sectionRaw: "Weather app",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>*",
          "Wybierz widget <strong>Pogoda</strong>",
          "Wybierz ikonę <strong>Menu</strong>",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Wybierz obecną lokalizację domyślną",
          "Wyszukaj nową lokalizację lub wybierz <strong>Użyj mojej bieżącej lokalizacji</strong>**",
          "Wybierz <strong>Gotowe</strong>",
        ],
        note: "*Możesz także odkryć ikonę aplikacji i otwierać ją, wybierając <strong>Aplikacje</strong> > <strong>Pogoda</strong>\n**Może być konieczna zmiana ustawień udostępniania lokalizacji w Ustawieniach",
      },
    ],
  },

  // Managing files section
  "transfer-photos-to-kompakt": {
    image_main: publicImagePaths.managing_files_img_main,
    image: publicImagePaths.managing_files_img_1,
    articleTitle: "Jak przenieść zdjęcia na Kompakt",
    content: [
      {
        title: "Jak przenieść zdjęcia na Kompakt",
        section: "Zarządzanie plikami",
        sectionRaw: "Managing files",
        steps: [
          "Otwórz aplikację Mudita Center i podłącz urządzenie",
          "Wybierz <strong>Twój Kompakt</strong> > <strong>Zarządzaj plikami</strong>",
          "Kliknij <strong>Zdjęcia</strong>",
          "Kliknij <strong>Dodaj plik</strong>",
          "Wybierz obrazy* z komputera, które chcesz przesłać",
          "Potwierdź przesłanie zdjęć na Kompakt",
        ],
        note: "*Jeśli typ pliku nie jest obsługiwany przez Kompakt, nie będzie można go wybrać",
      },
    ],
  },

  "transfer-music-to-kompakt": {
    image_main: publicImagePaths.managing_files_img_main,
    image: publicImagePaths.managing_files_img_2,
    articleTitle: "Jak przenieść pliki muzyczne na Kompakt",
    content: [
      {
        title: "Jak przenieść pliki muzyczne na Kompakt",
        section: "Zarządzanie plikami",
        sectionRaw: "Managing files",
        steps: [
          "Otwórz aplikację Mudita Center i podłącz urządzenie",
          "Wybierz <strong>Twój Kompakt</strong> > <strong>Zarządzaj plikami</strong>",
          "Kliknij <strong>Muzyka</strong>",
          "Kliknij <strong>Dodaj plik</strong>",
          "Wybierz pliki audio* z komputera, które chcesz przesłać",
          "Potwierdź przesłanie muzyki na Kompakt",
        ],
        note: "*Jeśli typ pliku nie jest obsługiwany przez Kompakt, nie będzie można go wybrać",
      },
    ],
  },

  "transfer-ebooks-to-kompakt": {
    image_main: publicImagePaths.managing_files_img_main,
    image: publicImagePaths.managing_files_img_3,
    articleTitle: "Jak przenieść e-booki na Kompakt",
    content: [
      {
        title: "Jak przenieść e-booki na Kompakt",
        section: "Zarządzanie plikami",
        sectionRaw: "Managing files",
        steps: [
          "Otwórz aplikację Mudita Center i podłącz urządzenie",
          "Wybierz <strong>Twój Kompakt</strong> > <strong>Zarządzaj plikami</strong>",
          "Kliknij <strong>E-booki</strong>",
          "Kliknij <strong>Dodaj plik</strong>",
          "Wybierz pliki e-booków* z komputera, które chcesz przesłać",
          "Potwierdź przesłanie e-booków na Kompakt",
        ],
        note: "*Jeśli typ pliku nie jest obsługiwany przez Kompakt, nie będzie można go wybrać",
      },
    ],
  },

  "delete-files-from-kompakt": {
    image_main: publicImagePaths.managing_files_img_main,
    image: publicImagePaths.managing_files_img_4,
    articleTitle: "Jak usunąć pliki z Kompakta",
    content: [
      {
        title: "Jak usunąć pliki z Kompakta",
        section: "Zarządzanie plikami",
        sectionRaw: "Managing files",
        steps: [
          "Otwórz aplikację Mudita Center i podłącz urządzenie",
          "Wybierz <strong>Twój Kompakt</strong> > <strong>Zarządzaj</strong> (Muzyka, Zdjęcia lub E-booki)",
          "Przejdź do plików, które chcesz usunąć",
          "Zaznacz pliki przy użyciu <strong>Pól wyboru</strong>*",
          "Kliknij <strong>Usuń</strong>",
          "Kliknij ponownie <strong>Usuń plik</strong>",
        ],
        note: "*Aby zaznaczyć wszystkie pliki, kliknij ikonę minusa na górze ekranu",
      },
    ],
  },

  // Backup and restore section
  "create-backup": {
    image_main: publicImagePaths.backup_and_restore_img_main,
    image: publicImagePaths.backup_and_restore_img_1,
    articleTitle: "Jak utworzyć kopię zapasową Kompakta",
    content: [
      {
        title: "Jak utworzyć kopię zapasową Kompakta",
        section: "Kopie zapasowe i przywracanie danych",
        sectionRaw: "Backup and restore",
        steps: [
          "Otwórz aplikację Mudita Center i podłącz urządzenie",
          "Wybierz <strong>Twój Kompakt</strong> > <strong>Podgląd</strong>",
          "Kliknij <strong>Utwórz kopię zapasową</strong>",
          "Kliknij ponownie <strong>Utwórz kopię zapasową</strong>, aby potwierdzić",
          "Utwórz hasło, aby chronić dane kopii zapasowej*",
          "Kliknij <strong>Potwierdź hasło</strong>",
          "Wprowadź swoje hasło, aby rozpocząć tworzenie kopii",
        ],
        note: "*Uwaga! Po potwierdzeniu nie będzie można zmienić hasła.\nJeśli nie chcesz ustawiać hasła, kliknij <strong>Pomiń hasło</strong>",
      },
    ],
  },

  "restore-from-backup": {
    image_main: publicImagePaths.backup_and_restore_img_main,
    image: publicImagePaths.backup_and_restore_img_2,
    articleTitle: "Jak przywrócić dane z kopii zapasowej",
    content: [
      {
        title: "Jak przywrócić dane z kopii zapasowej",
        section: "Kopie zapasowe i przywracanie danych",
        sectionRaw: "Backup and restore",
        steps: [
          "Otwórz aplikację Mudita Center i podłącz urządzenie",
          "Wybierz <strong>Twój Kompakt</strong> > <strong>Podgląd</strong>",
          "Kliknij <strong>Przywróć z kopii zapasowej</strong>",
          "Z listy wybierz kopię zapasową, z której chcesz przywrócić dane",
          "Kliknij ponownie <strong>Przywróć z kopii zapasowej</strong>",
          "Wprowadź hasło zabezpieczające kopię*",
          "Kliknij <strong>Potwierdź</strong>",
        ],
        note: "*Uwaga! Nie ma możliwości odzyskania lub zmiany hasła do kopii zapasowej.\nJeśli nie ustawiono hasła, ten krok zostanie pominięty i rozpocznie się proces przywracania",
      },
    ],
  },

  "find-backup-file": {
    image_main: publicImagePaths.backup_and_restore_img_main,
    image: publicImagePaths.backup_and_restore_img_3,
    articleTitle: "Jak znaleźć plik kopii zapasowej na komputerze",
    content: [
      {
        title: "Jak znaleźć plik kopii zapasowej na komputerze",
        section: "Kopie zapasowe i przywracanie danych",
        sectionRaw: "Backup and restore",
        steps: [
          "Otwórz aplikację Mudita Center i podłącz urządzenie",
          "Wybierz <strong>Mudita Center</strong> > <strong>Ustawienia</strong>*",
          "Zobaczysz ścieżkę pliku (np. C:/Użytkownik/Dokumenty/Mudita/Kompakt/backup)",
          "Skorzystaj z przeglądarki plików na komputerze, aby przejść do podanej lokalizacji",
        ],
        note: "*Karta Kopia zapasowa otwiera się domyślnie. Jeśli nie, kliknij <strong>Backup</strong> na górze ekranu",
      },
    ],
  },

  // Updating Kompakt section
  "manually-check-updates": {
    image_main: publicImagePaths.updating_kompakt_img_main,
    image: publicImagePaths.updating_kompakt_img_1,
    articleTitle:
      "Jak samodzielnie sprawdzić dostępność nowych aktualizacji MuditaOS K",
    content: [
      {
        title:
          "Jak samodzielnie sprawdzić dostępność nowych aktualizacji MuditaOS K",
        section: "Aktualizowanie Kompakta",
        sectionRaw: "Updating Kompakt",
        steps: [
          "Upewnij się, że Kompakt jest połączony z internetem",
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>O urządzeniu</strong>",
          "Wybierz <strong>Aktualizacja oprogramowania</strong>",
          "Jeśli aktualizacja jest dostępna, możesz zaktualizować MuditaOS K",
        ],
      },
    ],
  },

  "update-kompakt": {
    image_main: publicImagePaths.updating_kompakt_img_main,
    image: publicImagePaths.updating_kompakt_img_2,
    articleTitle: "Jak zaktualizować MuditaOS K na Kompakcie",
    description: `Powiadomienie o dostępności nowej aktualizacji oprogramowania będzie widoczne na szczycie Centrum sterowania. Możesz też samodzielnie sprawdzić dostępność aktualizacji.`,
    content: [
      {
        title: "Jak zaktualizować MuditaOS K na Kompakcie",
        section: "Aktualizowanie Kompakta",
        sectionRaw: "Updating Kompakt",
        steps: [
          "Upewnij się, że Kompakt jest połączony z internetem",
          "Wybierz powiadomienie o <strong>nowej aktualizacji MuditaOS K</strong>",
          "Wybierz <strong>Aktualizuj</strong>",
          "W razie potrzeby: przeczytaj, zaznacz odpowiednie <strong>pole wyboru</strong> i wybierz <strong>Zgadzam się</strong> na warunki licencji",
          "Aktualizacja zostanie automatycznie pobrana i skonfigurowana",
          "Wybierz <strong>Uruchom ponownie</strong>",
        ],
      },
    ],
  },

  // Calling section
  "make-call": {
    image_main: publicImagePaths.calling_img_main,
    image: publicImagePaths.calling_img_1,
    articleTitle: "Jak zadzwonić z Mudita Kompakt",
    content: [
      {
        title: "Aby zadzwonić do zapisanego kontaktu:",
        section: "Połączenia telefoniczne",
        sectionRaw: "Calling",
        steps: [
          "Wybierz <strong>Telefon</strong>",
          "Wybierz <strong>Kontakty</strong>",
          "Wybierz kontakt, do którego chcesz zadzwonić",
          "Wybierz ikonę <strong>Zadzwoń</strong>",
        ],
      },
      {
        title: "Aby zadzwonić na nowy numer:",
        section: "Połączenia telefoniczne",
        sectionRaw: "Calling",
        steps: [
          "Wybierz <strong>Telefon</strong>",
          "Wybierz <strong>Wybierz numer</strong>",
          "Wprowadź numer, na który chcesz zadzwonić",
          "Wybierz ikonę <strong>Zadzwoń</strong>",
        ],
      },
    ],
  },

  "change-emergency-number": {
    image_main: publicImagePaths.calling_img_main,
    image: publicImagePaths.calling_img_2,
    articleTitle: "Jak zmienić numer alarmowy",
    description: `<strong>Uwaga! Po zmianie numeru alarmowego Twoje połączenie alarmowe może nie zostać odebrane!</strong> Domyślnie ustawiony numer alarmowy łączy z lokalnymi służbami ratunkowymi w Twoim regionie.`,
    content: [
      {
        title: "Aby zmienić numer alarmowy:",
        section: "Połączenia telefoniczne",
        sectionRaw: "Calling",
        steps: [
          "Naciśnij przycisk <strong>Centrum sterowania</strong>",
          "Wybierz ikonę <strong>Ustawienia</strong>",
          "Wybierz <strong>Bezpieczeństwo i sytu…</strong>",
          "Wybierz <strong>Połączenie alarmowe</strong>",
          "Wybierz <strong>Zadzwoń w sytuacji awaryjnej</strong>",
          "Wybierz <strong>obecnie ustawiony numer</strong>",
          "Wprowadź nowy numer",
          "Wybierz <strong>Zapisz</strong>",
        ],
        note: "Domyślnie ustawiony numer alarmowy łączy z lokalnymi służbami ratunkowymi w Twoim regionie.",
      },
    ],
  },

  // Calendar app section
  "create-calendar-event": {
    articleTitle: "Jak utworzyć wydarzenie w Kalendarzu",
    image_main: publicImagePaths.calendar_app_img_main,
    image: publicImagePaths.calendar_app_img_main,
    content: [
      {
        title: "Jak utworzyć wydarzenie w Kalendarzu",
        section: "Aplikacja Kalendarza",
        sectionRaw: "Calendar app",
        steps: [
          "Wybierz <strong>dzisiejszą datę</strong> na ekranie głównym*",
          "Użyj <strong>strzałek w lewo i prawo</strong>, aby wybrać miesiąc",
          "Wybierz <strong>dzień</strong>, w którym chcesz dodać wydarzenie",
          "Wybierz ikonę <strong>Plusa</strong>",
          "Wybierz <strong>Dodaj tytuł</strong>, aby nadać wydarzeniu nazwę",
          "Użyj <strong>strzałek góra/dół</strong>, aby ustawić godzinę rozpoczęcia",
          "Użyj <strong>strzałek góra/dół</strong>, aby ustawić godzinę zakończenia",
          "Wybierz <strong>Utwórz</strong>",
        ],
        note: "*Możesz także odkryć ikonę aplikacji, aby uzyskać do niej dostęp poprzez wybór <strong>Aplikacje</strong>, a następnie <strong>Kalendarz</strong>",
      },
    ],
  },
  "unblock-contacts": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_1,
    articleTitle: "Jak odblokować kontakt na Kompakcie",
    content: [
      {
        title: "Jak odblokować kontakt na Kompakcie",
        section: "Zarządzanie kontaktami",
        sectionRaw: "Managing contacts",
        steps: [
          "Wybierz <strong>Telefon</strong>",
          "Wybierz <strong>Kontakty</strong>",
          "Wybierz kontakt, który chcesz odblokować",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Wybierz ikonę <strong>Blokowania</strong>",
          "Wybierz <strong>Odblokuj kontakt</strong>",
        ],
      },
    ],
  },
  "block-contacts": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_2,
    articleTitle: "Jak zablokować kontakt na Kompakcie",
    content: [
      {
        title: "Jak zablokować kontakt na Kompakcie",
        section: "Zarządzanie kontaktami",
        sectionRaw: "Managing contacts",
        steps: [
          "Wybierz <strong>Telefon</strong>",
          "Wybierz <strong>Kontakty</strong>",
          "Wybierz kontakt, który chcesz zablokować",
          "Wybierz ikonę <strong>Ołówka</strong>",
          "Wybierz ikonę <strong>Blokowania</strong>",
          "Wybierz <strong>Zablokuj kontakt</strong>",
        ],
      },
    ],
  },

  "add-contacts-manually": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_3,
    articleTitle: "Jak ręcznie dodać kontakt na Kompakcie",
    content: [
      {
        title: "Jak ręcznie dodać kontakt na Kompakcie",
        section: "Zarządzanie kontaktami",
        sectionRaw: "Managing contacts",
        steps: [
          "Wybierz <strong>Telefon</strong>",
          "Wybierz <strong>Kontakty</strong>",
          "Wybierz ikonę <strong>Dodaj kontakt</strong>",
          "Wprowadź dane kontaktu",
          "Wybierz <strong>Utwórz</strong>",
        ],
      },
    ],
  },
}
